import Vue from 'vue';

import { CURRENCY } from '@/js/helpers/globalConst';

const priceSplitter = (num) => {
  if (num !== null && num !== '' && num !== undefined) {
    const str = num.toString().split('.');
    if (str[0].length) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    }
    return str.join('.');
  }
  return num;
};

const priceFormatted = (value, beforeText = '', setCurrency = true, setFreeText = true) => {
  if (value !== null && value !== '' && value !== undefined) {
    let text = priceSplitter(value);
    if (setCurrency || !setFreeText) {
      text = `${text} ${CURRENCY}`;
    }
    if (beforeText !== '' || !setFreeText) {
      text = `${beforeText} ${text}`;
    }
    if (setFreeText && value === 0) {
      text = 'Бесплатно';
    }
    return text;
  }
  return value;
};

Vue.filter('priceFormatted', (...attrs) => priceFormatted(...attrs));

Vue.filter('priceSplitter', value => priceSplitter(value));

export { priceSplitter, priceFormatted };
